export default __webpack_public_path__ + "static/media/user-avatar.aee4714e.png";